// 3rd-party modules
import { Outlet } from 'react-router-dom';
import useTranslation from '../hooks/TranslationContext';

export default function AuthLayout() {
  const { t } = useTranslation();
  return (
    <>
      <div className="flex flex-col md:flex-row h-screen bg-white">
        {/* Left Section */}
        <div className="flex flex-1 flex-col justify-center items-center p-5">
          <Outlet />
        </div>

        {/* Right Section */}
        <div className="flex-1 bg-main-dark text-white flex flex-col justify-center items-center text-center p-5 hidden md:flex">
          <h2 className="text-2xl font-semibold mb-3">{t("aban-management-application")}</h2>
          <p className="text-lg">{t("manage-your-company")} <br /> {t("from-anywhere")}</p>
        </div>
      </div>
    </>
  );
}
